import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { en, pl } from '@/app/common/util/translations';

@Component
export default class ValidationMessagesMixin extends Vue {
  get currentLang(): string {
    return this.$store.getters.currentLang;
  }

  public collectErrors(error: any, fieldName?: string): string[] {
    if (error.$dirty) {
      const errorBag = Object.keys(error.$params);
      return errorBag.filter(err => !error[err])
        .map(item => this.collect(item, fieldName ? fieldName.toLowerCase() : ''));
    }
    return [];
  }

  public collect(field: string, fieldName: string): string {
    const translations: { [key: string]: string } = this.translationsByLang(this.currentLang);
    return translations[field].replace('${}', fieldName);
  }

  private translationsByLang(lang: string): { [key: string]: string } {
    switch (lang) {
      case 'en':
        return en;
      case 'pl':
        return pl;
      default:
        return pl;
    }
  }
}
